// extracted by mini-css-extract-plugin
module.exports = {"reprocess-button":"WaveForm_reprocess-button__lUbtG","header":"WaveForm_header__2XFON"};